import React, { Fragment } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import { JOKI, initializeServices } from './JOKI';

import { useAuthenticationStatus } from './services/Authentication/AuthenticationHooks';
import { AUTH_STATUS } from './services/Authentication/AuthenticationService';

import SEPassportAuthenticationCallback from './services/Authentication/AuthenticationCallBack';

import HeadersContainer from './views/commons/HeadersContainer';
import LoginView from './views/LoginView/LoginView';
import AlarmsView from './views/AlarmView';
import DevicesView from './views/DevicesView';
import MapView from './views/MapView';
import OrganizationCrudView from './views/OrganizationCrudView';
import LocationCrudView from './views/LocationCrudView';
// import ReportView from './views/ReportView';
import DeviceInventoryView from './views/DeviceInventory';
import GlobalLoadingView from './views/GlobalLoadingView';

import 'selfly-ui-core/dist/scss/index.scss';

import './App.scss';
import { useCurrentUserAccessibility } from './services/User/UserHooks';

initializeServices(JOKI);

function App(props) {
    const [authStatus] = useAuthenticationStatus();

    // console.log("App Props authStatus", authStatus);
    return (
        <div className="App">
            {authStatus !== AUTH_STATUS.ok && (
                <Router>
                    <React.Fragment>
                        <Route exact path="/callback" component={SEPassportAuthenticationCallback} />
                        <Route path="/" component={LoginView} />
                    </React.Fragment>
                </Router>
            )}
            {authStatus === AUTH_STATUS.ok && (
                <Router>
                    <Route component={MainView} />
                </Router>
            )}
        </div>
    );
}

/**
 * This MainView is here to make sure the HeadersContainer is not rendered unless absolutely necessary.
 * @param {*} props
 */
function MainView(props) {
    // const isGlobalAdmin = useCurrentUserIsAdmin();
    const {permissions, permissionState, user} = useCurrentUserAccessibility();
    const validPathNames = ['/alarms', '/history', '/devices', '/map', '/deviceinventory', '/callback'];

    if (!permissions.includes('globalAdmin')) {
        if (permissions.includes('organizationCRUD')) {
            validPathNames.push('/organizations');
        }
        if (permissions.includes('locationCRUD')) {
            validPathNames.push('/locations');
        }
    } else {
        validPathNames.push('/organizations', '/locations');
    }

    const isInvalidPath = !validPathNames.includes(props.location.pathname);

    return (
        <Fragment>
            <HeadersContainer {...props} permissions={permissions} user={user}/>

            {/* <Route path="/history" component={HistoryView} /> */}
            <Route path="/devices" render={(props) => <DevicesView {...props} permissions={permissions}/>}/>
            <Route path="/map" render={(props) => <MapView {...props} permissions={permissions}/>}/>
            <Route path="/deviceinventory" render={(props) => <DeviceInventoryView {...props} permissions={permissions}/>}/>

            {permissions.includes('organizationCRUD') && <Route path="/organizations" render={(props) => <OrganizationCrudView {...props} permissions={permissions}/>}/>}

            {permissions.includes('locationCRUD') && <Route path="/locations" render={(props) => <LocationCrudView {...props}  permissions={permissions}/>}/>}

            <Route exact path="/alarms" render={(props) => <AlarmsView {...props} permissions={permissions}/>}/>
            {props.location.pathname !== '/alarms' && permissionState === 'Loading' ? 
                <Route path="/" component={GlobalLoadingView} /> : 
                isInvalidPath && <Route path="/" render={(props) => <AlarmsView {...props} permissions={permissions}/>}/> }
        </Fragment>
    );
}

export default App;
